const ServerUrl = {
  BASE_URL: "https://chat-back.div-systems.com/",
  WS_BASE_URL: "ws:https://chat-back.div-systems.com/",
};

export default ServerUrl;
